
<form #f="ngForm" (ngSubmit)="saveUser()">
    <div class="p-grid">
        <div class="p-col-12 error-notify-text">
            <app-validateform [formToValidate]="editUserForm"></app-validateform>
        </div>
    </div>
    <div>
        <div class="p-grid">
            <div class="p-col-12 page-header">Update Profile</div>
            <div class="p-col-12 divider-header">
                <p-divider></p-divider>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-2" *ngIf="canEditProfile">
                <button pButton type="submit" class="fullwidthbtn" label="Save"></button>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                <button pButton type="button" class="fullwidthbtn" label="Cancel" routerLink="/user/{{user.Id}}"></button>
            </div>
        </div>
        <div>
            <p-accordion [multiple]="true" *ngIf="user">
                <p-accordionTab header="USER INFORMATION" [selected]="true">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-3 p-md-3">
                            <img class="p-col-12 profilePicture" [src]="user.ProfilePicture" />
                        </div>
                        <div class="p-col-12 p-lg-9 p-md-9">
                            <div class="p-grid">
                                <div class="p-col-12" *ngIf="canActivateUser">
                                    <p-checkbox [(ngModel)]="user.Active"
                                                binary="true"
                                                inputId="binary"
                                                name="Active"
                                                label="Active"
                                                (onChange)="onChangeActivateProfile()">
                                    </p-checkbox>
                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.FName"
                                               name="FirstName"
                                               requiredNoSpaceValidator
                                               data-display-name="FirstName" />
                                        <label for="float-input">First Name*</label>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.LName"
                                               name="LastName"
                                               requiredNoSpaceValidator
                                               data-display-name="LastName" />
                                        <label for="float-input">Last Name*</label>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.Email"
                                               name="Email"
                                               requiredNoSpaceValidator
                                               data-display-name="Email" />
                                        <label for="float-input">Email*</label>
                                    </span>

                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.Title"
                                               name="Title"
                                               requiredNoSpaceValidator
                                               data-display-name="Title" />
                                        <label for="float-input">Title*</label>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">                                    
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.DirectPhone"
                                               name="DirectPhone"
                                               requiredNoSpaceValidator
                                               data-display-name="Direct Phone" 
                                           
                                               />
                                        <label  for="p-float-label">Direct Phone*</label>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.DirectPhoneExtn"
                                               name="Extension" />
                                        <label for="p-float-label">Extension</label>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.CellPhone"
                                               name="CellPhone" />
                                        <label for="p-float-label">Cell Phone</label>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.Fax"
                                               name="Fax" />
                                        <label for="p-float-label">Fax</label>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.SEOName"
                                               name="SEOName" />
                                        <label for="p-float-label">SEO Name</label>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-6 p-md-6">
                                    <span class="p-float-label">
                                        <input type="text"
                                               pInputText
                                               [(ngModel)]="user.MyPropertyListingUrl"
                                               name="MyPropertyListings" />
                                        <label for="p-float-label">My Property Listings URL</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12">
                                <p-message severity="info" text="Check whether the phone numbers are in correct format, which is +country code region code (if applicable) and phone number, for example: +1 XXX XXX XXXX. You must use this format for both domestic and international phone numbers. Your phone number will appear exactly as entered." styleClass="mr-2"></p-message>
                            </div>
                        </div>
                        <div class="p-col-12">
                            <p-fileUpload name="ProfilePicture"
                                          url="{{uploadURLPhoto}}"
                                          accept="image/*"
                                          multiple="single"
                                          chooseLabel="Update Profile Photo"
                                          [showUploadButton]="false"
                                          [showCancelButton]="false"
                                          (onBeforeUpload)="onBeforeUploadProfilePicture($event)"
                                          (onUpload)="onUploadCompletedProfilePicture($event)">
                            </p-fileUpload>
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="SOCIAL MEDIA">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-4 p-md-4">
                            <div class="p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="user.FacebookID"
                                           name="FacebookID" />
                                    <label for="float-input">Facebook ID</label>
                                </span>
                                <button *ngIf="user.FacebookID" type="button" pButton pRipple icon="pi pi-check"  pTooltip="Test Link"  (click)="testLink('//www.facebook.com/' + user.FacebookID)"></button>
                            </div>                          
                        </div>
                        <div class="p-col-12 p-lg-4 p-md-4">
                            <div class="p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="user.TwitterID"
                                           name="TwitterID" />
                                    <label for="float-input">Twitter ID</label>
                                </span>
                                <button *ngIf="user.TwitterID" type="button" pButton pRipple icon="pi pi-check"  pTooltip="Test Link" (click)="testLink('//www.twitter.com/' + user.TwitterID)"></button>
                            </div>                           
                        </div>
                        <div class="p-col-12 p-lg-4 p-md-4">
                            <div class="p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="user.YoutubeID"
                                           name="YoutubeID" />
                                    <label for="float-input">Youtube ID</label>
                                </span>
                                <button *ngIf="user.YoutubeID" type="button" pButton pRipple icon="pi pi-check"  pTooltip="Test Link" (click)="testLink('//www.youtube.com/' + user.YoutubeID)"></button>
                            </div>                           
                        </div>
                        <div class="p-col-12 p-lg-4 p-md-4">
                            <div class="p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="user.InstagramID"
                                           name="Instagram" />
                                    <label for="float-input">Instagram ID</label>
                                </span>
                                <button *ngIf="user.InstagramID" type="button" pButton pRipple icon="pi pi-check"  pTooltip="Test Link" (click)="testLink('//www.instagram.com/' + user.InstagramID)"></button>
                            </div>                         
                        </div>
                        <div class="p-col-12 p-lg-4 p-md-4">
                            <div class="p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="user.LinkedINID"
                                           name="LinkedINID" />
                                    <label for="p-float-label">LinkedIN ID</label>
                                </span>
                                <button *ngIf="user.LinkedINID" type="button" pButton pRipple icon="pi pi-check"  pTooltip="Test Link" (click)="testLink('//www.linkedin.com/company/' + user.LinkedINID)"></button>
                            </div>                         
                        </div>
                        <div class="p-col-12 p-lg-12 p-md-12">
                            <div class="p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="user.BlogUrl"
                                           name="BlogUrl" />
                                    <label for="p-float-label">Blog Url</label>
                                </span>
                                <button *ngIf="user.BlogUrl" type="button" pButton pRipple icon="pi pi-check"  pTooltip="Test Link" (click)="testLink('//' + user.BlogUrl)"></button>
                            </div>                          
                        </div>
                        <div class="p-col-12 p-lg-12 p-md-12">
                            <div class="p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="user.BlogRSSFeedUrl"
                                           name="BlogRSSFeedUrl" />
                                    <label for="p-float-label">Blog RSS/Feed Url</label>
                                </span>
                                <button *ngIf="user.BlogRSSFeedUrl" type="button" pButton pRipple icon="pi pi-check"  pTooltip="Test Link" (click)="testLink('//' + user.BlogRSSFeedUrl)"></button>
                            </div>                          
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="PROFESSIONAL BACKGROUND">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.LicenseNumber"
                                       name="LicenseNumber" />
                                <label for="float-input">License #</label>
                            </span>
                        </div>        
                        <div class="p-col-12 p-lg-6 p-md-6">

                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.PrimarySpecialty"
                                       name="PrimarySpecialty" />
                                <label for="float-input">Primary Specialty</label>
                            </span>
                        </div>                 
                        <div class="p-col-12 p-lg-5 p-md-5" *ngIf="specialtyOptions">
                            <span class="p-float-label">
                                <p-multiSelect [options]="specialtyOptions"
                                               [(ngModel)]="user.Specialties"
                                               optionLabel="Name"
                                               name="Specialties"
                                               [style]="{width:'100%', height:'45px'}">
                                </p-multiSelect>
                                <label for="float-input">Specialties</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-1 p-md-1">
                            <button pButton type="button"
                                    pTooltip="Update Specialties"
                                    class="fullwidthbtn" icon="pi pi-cog"
                                    (click)="showUpdateSpecialties()"></button>
                        </div>
                        <div class="p-col-12 p-lg-12 p-md-12">
                            <h6>Scope Of Experience</h6>
                            <p-editor placeholder="Scope Of Experience"
                                      [(ngModel)]="user.ScopeOfExperience"
                                      [style]="{'height':'200px'}"
                                      name="ScopeOfExperience"></p-editor>
                            <h6>Background & Experience</h6>
                            <p-editor placeholder="Background & Experience"
                                      [(ngModel)]="user.Bio"
                                      [style]="{'height':'200px'}"
                                      name="Bio"></p-editor>
                            <h6>Professional Affiliations</h6>
                            <p-editor placeholder="Professional Affiliations"
                                      [(ngModel)]="user.ProfessionalAffiliations"
                                      [style]="{'height':'200px'}"
                                      name="ProfessionalAffiliations"></p-editor>
                            <h6>Education Description</h6>
                            <p-editor placeholder="Education Description"
                                      [(ngModel)]="user.EducationDescription"
                                      [style]="{'height':'200px'}"
                                      name="EducationDescription"></p-editor>
                            <h6>Significant Transactions</h6>
                            <p-editor placeholder="Significant Transactions"
                                      [(ngModel)]="user.SignificantTransactions"
                                      [style]="{'height':'200px'}"
                                      name="SignificantTransactions"></p-editor>
                            <h6>Strategic Clients</h6>
                            <p-editor placeholder="Strategic Clients"
                                      [(ngModel)]="user.StrategicClients"
                                      [style]="{'height':'200px'}"
                                      name="StrategicClients"></p-editor>
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="OFFICES">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <button pButton type="button" label="Add Office" (click)="showAdd()"></button>
                            <p-message severity="info" text="Once you have added the office to the user’s profile, click on edit to assign their role." styleClass="mr-2"></p-message>
                            
                        </div>
                        <div class="p-col-12">
                            <p-table #dt [value]="user.Members" responsiveLayout="scroll"
                                     [rowHover]="true" dataKey="Id"
                                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                     [showCurrentPageReport]="true"
                                     styleClass="p-datatable-items">
                                <ng-template pTemplate="body" let-member>
                                    <tr *ngIf="member.Member.Active == true">
                                        <td>{{member.Member.Name}}</td>
                                        <td>{{member.Member.City}}</td>
                                        <td>{{member.Member.StatesName}}</td>
                                        <td>
                                            <p-checkbox name="{{member.Id + member.Member.Name + member.Member.City + member.Member.StatesName}}" readonly="true" binary="true" inputId="binary" [(ngModel)]="member.IsDefaultMember"></p-checkbox>
                                            <label>Is Default</label>
                                        </td>
                                        <td>
                                            <div class="floatRight">
                                                <button pButton type="button" label="Edit" (click)="showEdit(member)" ></button>
                                                <button pButton type="button" label="Delete" (click)="deleteOffice(member)" [disabled]="member.IsDefaultMember"></button>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>                   
                </p-accordionTab>
                <p-accordionTab header="SECURITY ROLES">
                    <div *ngFor="let role of appRoleOptions" class="p-field-checkbox">
                        <p-checkbox name="{{role.Id}}groupAppRoles"
                                    value="role"
                                    [value]="role"
                                    [(ngModel)]="selectedAppRoles"
                                    [inputId]="role.Id"                                                                        
                                    [disabled]="shouldDisableSecurityRoleCheckbox(role.Name)">
                        </p-checkbox>
                        <label>{{role.Description}}</label>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </div>
    </div>
</form>
<p-dialog draggable="false" modal="true" header="Edit Office" [(visible)]="showEditOffice" [closable]="false" styleClass="dialog-medium">
    <p-divider></p-divider>
    <div class="p-grid">
        <div class="p-col-12 p-lg-6 p-md-6">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="selectedOffice.Title"
                       name="FirstName" />
                <label for="float-input">Title</label>
            </span>
        </div>
        <div class="p-col-12 p-lg-6 p-md-6">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="selectedOffice.OfficePhone"
                       name="LastName" />
                <label for="float-input">OfficePhone</label>
            </span>
        </div>
        <div class="p-col-12 p-lg-6 p-md-6">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="selectedOffice.Fax"
                       name="Email" />
                <label for="float-input">Fax</label>
            </span>

        </div>
        <div class="p-col-12 p-lg-6 p-md-6">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="selectedOffice.Email"
                       name="Title" />
                <label for="float-input">Email</label>
            </span>
        </div>
        <div class="p-col-12">
            <p-checkbox name="{{selectedOffice.Id}}"
                        binary="true"
                        inputId="binary"
                        [(ngModel)]="selectedOffice.IsDefaultMember"
                        ></p-checkbox>
            <label>Is Default</label>
        </div>
        <div class="p-col-12"><strong>Roles</strong></div>
        <div class="p-col-12" style="padding-left:40px;">
            <div *ngFor="let role of roleOptions" class="p-field-checkbox">
                <p-checkbox name="{{selectedOffice.Id}}groupRoles"
                            value="role"
                            [value]="role"
                            [inputId]="role.Id"
                            [(ngModel)]="selectedOffice.Roles"
                            data-display-name="Office Role">
                </p-checkbox>
                <label pTooltip="{{role.ToolTip}}">{{role.Name}}</label>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Save" (click)="saveOffice()"></button>
        <button pButton type="button" label="Cancel" (click)="cancelSaveOffice()"></button>
    </ng-template>
</p-dialog>

<p-dialog draggable="false" modal="true" header="Add Office" [(visible)]="showAddOffice" [closable]="false" styleClass="dialog-medium">
    <p-divider></p-divider>
    <div class="p-grid">
        <div class="p-col-12">
            <span class="p-float-label">
                <p-dropdown inputId="dropdown"
                            [autoDisplayFirst]="false"
                            [showClear]="true"
                            [options]="parentOfficeOptions"
                            [(ngModel)]="AddOfficeParentOfficeId"
                            name="AddOfficeParentOfficeId"
                            (onChange)="onParentOfficeChange()"
                            scrollHeight="450px"
                            appendTo="body"
                            [filter]="true" filterBy="label">
                </p-dropdown>
                <label for="dropdown">Parent Office</label>
            </span>
        </div>

        <div class="p-grid">
            <div class="p-col-12">
                <div *ngFor="let office of childOffices" class="p-field-checkbox">
                    <div class="p-col-12">
                        <p-checkbox name="groupChildOffices" value="office" [value]="office" [(ngModel)]="selectedChildOffices" [inputId]="office.Id" data-display-name="Child Office(s)"></p-checkbox>
                        <label> {{office.Name}}, {{office.City}} {{office.StatesName}} {{office.CountryID == 221 ? '' : office.CountriesName}}</label>
                    </div>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton type="button" label="Add" (click)="addOffice()"></button>
            <button pButton type="button" label="Cancel" (click)="cancelAddOffice()"></button>
        </ng-template>
    </div>
</p-dialog>

<p-confirmDialog header="Confirmation" key="userEditConfirmDialog" icon="pi pi-exclamation-triangle" [style]="{width: '50vw'}"></p-confirmDialog>
<p-dialog draggable="false" modal="true" [closable]="false" header="Warning" [(visible)]="showDuplicateItemDialog">
    <p-divider></p-divider>
    <span class="ui-confirmdialog-message"><pre>{{duplicateItemMessage}}</pre></span>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="OK" (click)="hideDuplicateItemDialog()"></button>
    </ng-template>
</p-dialog>

<p-dialog draggable="false" modal="true" header="Update Specialties" [(visible)]="showUpdateSpecialtiesDialog" [closable]="false" styleClass="dialog-large">
    <p-divider></p-divider>
    <div class="p-grid">
        <div class="p-col-12 p-lg-12 p-md-12">
            <div class="p-inputgroup">
                <span class="p-float-label">
                    <input type="text"
                           pInputText
                           [(ngModel)]="newSpecialty"
                           name="newSpecialty" />
                    <label for="float-input">Specialty</label>
                </span>
                <button pButton type="button" label="Add" (click)="addSpecialty()"></button>
            </div>           
        </div>      
        <div class="p-col-12">
            <p-table [value]="specialtyOptions">
                <ng-template pTemplate="body" let-specialty>
                    <tr>
                        <td>{{specialty.Name}}</td>
                        <td>
                            <div class="floatRight">
                                <button pButton type="button" label="Delete" (click)="deleteSpecialty(specialty)"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <ng-template pTemplate="footer">
            <button pButton type="button" label="Save" (click)="saveSpecialties()"></button>
            <button pButton type="button" label="Cancel" (click)="cancelSpecialties()"></button>
        </ng-template>
        </div>
</p-dialog>
